import { gql } from "@apollo/client";

// export const LOGIN = gql`
//   mutation Login($login_id: String!, $password: String!) {
//     login(login_input: { login_id: $login_id, password: $password }) {
//         data {
//             token {
//                 access_token
//                 expires_in
//                 refresh_token
//                 token_type
//             }
//             user {
//                 created_at
//                 email
//                 id
//                 mobile_no
//                 name
//                 status
//                 updated_at
//                 user_identifier
//                 roles {
//                     description
//                     id
//                     name
//                     permissions {
//                         created_at
//                         id
//                         role_id
//                         updated_at
//                         action {
//                             action
//                             created_at
//                             id
//                             name
//                             updated_at
//                             resource {
//                                 created_at
//                                 display
//                                 id
//                                 menu
//                                 name
//                                 updated_at
//                                 module {
//                                     created_at
//                                     display
//                                     id
//                                     menu
//                                     name
//                                     updated_at
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//         error {
//             code
//             field
//             message
//         }
//     }
// }
// `;
export const LOGIN = gql`
    mutation Login($login_id: String!, $password: String!) {
        login(login_input: { login_id: $login_id, password: $password }) {
            data {
            token {
                access_token
                refresh_token
                expires_in
                token_type
            }
            user {
                name
                mobile_no
                updated_at
                id
                user_identifier
                created_at
                email
                status
                roles {
                    description
                    id
                    name
                    permissions {
                        created_at
                        updated_at
                        id
                        role_id
                        action {
                            id
                            name
                            action
                            created_at
                            updated_at
                            resource {
                                id
                                name
                                menu
                                display
                                created_at
                                updated_at
                                module {
                                    id
                                    name
                                    menu
                                    display
                                    created_at
                                    updated_at
                                }
                            }
                        }
                    }
                }
            }
        }
            error {
                field
                message
                code
            }
        }
    }
`;
